import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '@components/common/Container';
import { BodyText, Overline, PageSection, SectionTitle } from '@components/common/Editorial';
const groups = [
    { key: 'guidance', items: ['dailyUse', 'mobile', 'purchases'] },
    { key: 'protection', items: ['scam', 'backups', 'credentials'] },
    { key: 'vip', items: ['contact', 'technician', 'maintenance'] },
    { key: 'ai', items: ['supervisedAi'] }
];
export const PlanBenefits = () => {
    const { t } = useTranslation();
    return (_jsx(Benefits, { "aria-labelledby": "plan-benefits-title", children: _jsxs(Container, { children: [_jsx(Overline, { children: t('products.personalCare360.name') }), _jsx(SectionTitle, { id: "plan-benefits-title", children: t('personalCare360.included') }), _jsx(BodyText, { children: t('personalCare360.includedIntro') }), _jsx(Groups, { children: groups.map((group, groupIndex) => (_jsxs(Group, { children: [_jsxs(GroupHeading, { children: [_jsxs("span", { "aria-hidden": "true", children: ["0", groupIndex + 1] }), _jsx("h3", { children: t(`personalCare360.groups.${group.key}.title`) }), _jsx("p", { children: t(`personalCare360.groups.${group.key}.intro`) })] }), _jsx("ul", { children: group.items.map((item) => (_jsxs("li", { children: [_jsx("strong", { children: t(`personalCare360.features.${item}.title`) }), _jsx("p", { children: t(`personalCare360.features.${item}.body`) })] }, item))) })] }, group.key))) })] }) }));
};
const Benefits = styled(PageSection) `
  background: ${({ theme }) => theme.colors.surface};
`;
const Groups = styled.div `
  margin-top: 2.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.navy900};
`;
const Group = styled.section `
  display: grid;
  grid-template-columns: minmax(220px, 0.75fr) minmax(0, 1.25fr);
  gap: 2rem 4rem;
  padding-block: 2.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    padding: 0 0 1.25rem;
    margin-bottom: 1.25rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  }
  li:last-child {
    margin: 0;
    padding: 0;
    border: 0;
  }
  li strong {
    color: ${({ theme }) => theme.colors.navy900};
    font-size: 1.05rem;
  }
  li p {
    margin: 0.45rem 0 0;
    color: ${({ theme }) => theme.colors.muted};
    line-height: 1.7;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;
const GroupHeading = styled.div `
  > span {
    color: ${({ theme }) => theme.colors.muted};
    font-size: 0.75rem;
  }
  h3 {
    margin: 0.5rem 0 0;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.25;
    letter-spacing: -0.035em;
  }
  p {
    margin: 0.8rem 0 0;
    color: ${({ theme }) => theme.colors.muted};
    line-height: 1.7;
  }
`;
